var _g;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgTickClose(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 20,
    viewBox: "0 0 19 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Tick Circle"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M13.8359 7.50008L11.0283 10.6361C9.91572 11.8787 9.35944 12.5001 8.6276 12.5001C7.89577 12.5001 7.33948 11.8787 6.22691 10.6361L5.5026 9.82705M18.0026 10.0001C18.0026 14.6025 14.2716 18.3334 9.66927 18.3334C5.0669 18.3334 1.33594 14.6025 1.33594 10.0001C1.33594 5.39771 5.0669 1.66675 9.66927 1.66675C14.2716 1.66675 18.0026 5.39771 18.0026 10.0001Z",
    stroke: "#F6F6F6",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  }))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTickClose);
export default __webpack_public_path__ + "static/media/tick-close.e07b77e7dee3ba031905a1334b19bd50.svg";
export { ForwardRef as ReactComponent };